import { CONFIG } from './config'

export const VALIDGUESSES = [
  'jidam',
  'niida',
  'niima',
  'jirrb',
  'wayji',
  'garar',
  'mayon',
  'maboo',
  'iilyi',
  'birar',
  'jagal',
  'bilij',
  'olard',
  'joodi',
  'boono',
  'irlin',
  'garma',
  'jamoo',
  'lolor',
  'lalin',
  'idoon',
  'rarrb',
  'midan',
  'gooda',
  'jarar',
  'jaban',
  'nimal',
  'galoo',
  'bardi',
  'jiila',
  'digal',
  'laybi',
  'roola',
  'norlo',
  'baala',
  'rooji',
  'biila',
  'balon',
  'ilboo',
  'daaga',
  'jajoo',
  'loomi',
  'arral',
  'olirr',
  'biini',
  'inara',
  'jaarr',
  'ngoma',
  'niyon',
  'mayar',
  'bardo',
  'digid',
  'jooga',
  'imoor',
  'nimbi',
  'baarl',
  'noorr',
  'irrin',
  'jardi',
  'jooyi',
  'odorr',
  'jarda',
  'diimi',
  'idool',
  'argal',
  'gooja',
  'danir',
  'ijawa',
  'idarr',
  'jabal',
  'jiibi',
  'wamba',
  'jalga',
  'wardi',
  'wirra',
  'gaari',
  'ininj',
  'injoo',
  'gawir',
  'malgi',
  'joowa',
  'goron',
  'joona',
  'garri',
  'dooda',
  'joord',
  'yaarl',
  'langa',
  'ginja',
  'inggi',
  'baadi',
  'boorb',
  'injar',
  'jaalo',
  'nalan',
  'bagon',
  'marrb',
  'inboo',
  'gooba',
  'maman',
  'baawa',
  'jinon',
  'miyal',
  'jarro',
  'wiirr',
  'aniya',
  'gondo',
  'ilirr',
  'goolb',
  'omban',
  'lalal',
  'biiwa',
  'joolb',
  'marla',
  'jibij',
  'injal',
  'imamb',
  'mayin',
  'ardan',
  'najir',
  'malar',
  'goola',
  'nimar',
  'jodon',
  'dayir',
  'baarr',
  'jardo',
  'inman',
  'inamb',
  'jiral',
  'binba',
  'arrgo',
  'jooda',
  'annid',
  'jarga',
  'bolin',
  'ngayi',
  'biido',
  'ngana',
  'irrmi',
  'gonko',
  'booyi',
  'layab',
  'inimi',
  'janko',
  'lordo',
  'jamba',
  'alals',
  'jamin',
  'laama',
  'imbin',
  'irran',
  'arlab',
  'diiji',
  'irrga',
  'galwa',
  'ingay',
  'daman',
  'baali',
  'banga',
  'biilo',
  'jiiya',
  'aanja',
  'minin',
  'gardi',
  'jonon',
  'boori',
  'wardo',
  'moowa',
  'gaygi',
  'darra',
  'wawoo',
  'jiman',
  'jiino',
  'naaga',
  'diimb',
  'oowoo',
  'iimid',
  'marab',
  'wigin',
  'bongo',
  'lirri',
  'arran',
  'biiwi',
  'ngidi',
  'manir',
  'gigal',
  'danan',
  'oonan',
  'jigid',
  'irrad',
  'oolin',
  'jarrb',
  'barri',
  'biyol',
  'waawi',
  'riwon',
  'inirr',
  'yiirr',
  'imarr',
  'booda',
  'niiya',
  'bijib',
  'jalba',
  'jiidi',
  'arrab',
  'ingor',
  'daaba',
  'gardo',
  'banam',
  'irrja',
  'maank',
  'onola',
  'inmin',
  'dodoy',
  'goono',
  'ilayi',
  'jaaga',
  'narrm',
  'alarr',
  'irrol',
  'miida',
  'jagij',
  'jawij',
  'irrmo',
  'ngami',
  'baloo',
  'minar',
  'giiji',
  'jaala',
  'booro',
  'biili',
  'janba',
  'giido',
  'rawin',
  'galar',
  'abini',
  'bodon',
  'baygo',
  'lanji',
  'iwala',
  'gaada',
  'arara',
  'arrba',
  'injij',
  'laarr',
  'garrj',
  'girdi',
  'oonki',
  'jaboo',
  'jonol',
  'inalb',
  'annga',
  'bargi',
  'wiira',
  'laban',
  'anala',
  'ngoor',
  'ramoo',
  'iyang',
  'alala',
  'yalar',
  'jarra',
  'minko',
  'lagal',
  'imada',
  'joonk',
  'dijin',
  'oonoo',
  'logon',
  'gaarr',
  'marda',
  'nilar',
  'dalga',
  'milji',
  'wiron',
  'alalo',
  'ingal',
  'dinin',
  'rarra',
  'bonka',
  'anini',
  'arana',
  'loowa',
  'iilon',
  'ambil',
  'ngama',
  'oorar',
  'inkal',
  'boolj',
  'olobo',
  'ajard',
  'irron',
  'joola',
  'boola',
  'baybi',
  'warli',
  'inarr',
  'gawoo',
  'amina',
  'nganj',
  'barli',
  'orror',
  'ninil',
  'aalin',
  'diiwa',
  'aliji',
  'jinan',
  'iiman',
  'birri',
  'warda',
  'anjin',
  'anina',
  'gaara',
  'booli',
  'irrba',
  'layar',
  'ginng',
  'miijo',
  'animi',
  'gooly',
  'janal',
  'manan',
  'alngi',
  'imimi',
  'jinko',
  'jinga',
  'yoorr',
  'mindi',
  'anirr',
  'mamin',
  'oolga',
  'aalig',
  'alaba',
  'larri',
  'boord',
  'niram',
  'inkan',
  'anggi',
  'noong',
  'iinar',
  'ayjiy',
  'larga',
  'orron',
  'niimi',
  'milan',
  'jinal',
  'diigi',
  'amanb',
  'janoo',
  'irrma',
  'joobi',
  'bilal',
  'nagir',
  'ininb',
  'galga',
  'arang',
  'garra',
  'oowin',
  'garon',
  'ganim',
  'jgidi',
  'yarra',
  'bilar',
  'darrb',
  'ijard',
  'ingon',
  'diird',
  'injin',
  'doorr',
  'jolon',
  'roowi',
  'jidni',
  'bajin',
  'looli',
  'aarla',
  'ngard',
  'ngali',
  'inina',
  'biiji',
  'boowa',
  'irral',
  'goona',
  'aloor',
  'oonko',
  'jorro',
  'jorli',
  'jalal',
  'marar',
  'jindi',
  'biija',
  'anara',
  'ankoo',
  'manka',
  'jirra',
  'jirdi',
  'ooroo',
  'goowa',
  'igarr',
  'layid',
  'aambi',
  'nirda',
  'ining',
  'bawin',
  'jabar',
  'goord',
  'angga',
  'joowi',
  'norla',
  'moord',
  'diidi',
  'ingar',
  'jinin',
  'inali',
  'iirri',
  'morla',
  'galbi',
  'arron',
  'darri',
  'marri',
  'ararr',
  'niman',
  'bonko',
  'janab',
  'ingga',
  'borlo',
  'billy',
  'mondo',
  'miboo',
  'janji',
  'igidi',
  'inana',
  'angan',
  'goori',
  'janan',
  'jawoo',
  'arjin',
  'angin',
  'jibir',
  'aamba',
  'doman',
  'iilan',
  'jibin',
  'jigal',
  'boror',
  'damba',
  'oomba',
  'barda',
  'mayil',
  'liibi',
  'janin',
  'jilma',
  'ngiil',
  'jawal',
  'oolab',
  'mamoo',
  'dooly',
  'arirr',
  'inama',
  'darab',
  'ooloo',
  'jibor',
  'inami',
  'yaala',
  'gadim',
  'aarli',
  'jinim',
  'diibo',
  'gaana',
  'anaya',
  'alymi',
  'barra',
  'ajirr',
  'anjoo',
  'miila',
  'ganda',
  'inono',
  'laada',
  'irrgo',
  'iirdi',
  'boyin',
  'anarr',
  'jigir',
  'ganba',
  'dimin',
  'layoo',
  'ajana',
  'niimo',
  'bambi',
  'jirrm',
  'ninka',
  'ambal',
  'marrj',
  'oonal',
  'mango',
  'garda',
  'ganal',
  'inala',
  'arlig',
  'nimin',
  'riiji',
  'irola',
  'nirdi',
  'indoo',
  'ngala',
  'ganid',
  'marra',
  'ninja',
  'jamal',
  'boond',
  'naawa',
  'jidin',
  'barla',
  'oolon',
  'baank',
  'doong',
  'glass',
  'jimad',
  'wirri',
  'ragal',
  'janga',
  'booll',
  'anama',
  'abarr',
  'madan',
  'moowo',
  'ambin',
  'aanga',
  'jirro',
  'malan',
  'irrai',
  'logal',
  'anani',
  'jirri',
  'baalo',
  'laaga',
  'goorr',
  'arrin',
  'jalja',
  'roong',
  'maaja',
  'amjin',
  'yaaga',
  'jargi',
  'jaarl',
  'boora',
  'biidi',
  'oolar',
  'irana',
  'balin',
  'jijar',
  'banar',
  'bilil',
  'aaman',
  'ingir',
  'galab',
  'riyar',
  'dirdi',
  'galin',
  'arroo',
  'anana',
  'oonka',
  'rolim',
  'ardio',
  'iwaya',
  'arrga',
  'nilal',
  'waygi',
  'anidi',
  'barka',
  'milon',
  'imorr',
  'aligi',
  'yirra',
  'oogoo',
  'mooni',
  'jimin',
  'jidij',
  'mooyi',
  'jilba',
  'nganb',
  'daarr',
  'alobo',
  'dirrb',
  'amboo',
  'janim',
  'diyil',
  'gooli',
  'jabij',
  'arril',
  'ninga',
  'malir',
  'jijin',
  'nilir',
  'wiiji',
  'daana',
  'aniba',
  'danim',
  'joorb',
  'goong',
  'andan',
  'manin',
  'jiido',
  'booba',
  'marga',
  'alabo',
  'ajina',
  'going',
  'biyal',
  'molon',
  'ilogo',
  'jiiwa',
  'jalji',
  'nalma',
  'boona',
  'igoon',
  'lagon',
  'aarlo',
  'biida',
  'oonba',
  'aalga',
  'iidan',
  'dingi',
  'ganan',
  'goroi',
  'gaalb',
  'balal',
  'joorr',
  'inimb',
  'banka',
  'rarrm',
  'ranan',
  'dinim',
  'lorda',
  'riiwa',
  'larda',
  'jagid',
  'amilj',
  'iinko',
  'nimid',
  'aralg',
  'gamba',
  'liyan',
  'ilgar',
  'aboor',
  'raali',
  'garrb',
  'milal',
  'albay',
  'marrg',
  'jiiba',
  'arari',
  'borla',
  'ngari',
  'joorl',
  'layib',
  'ayala',
  'indij',
  'mayoo',
  'imina',
  'galan',
  'anang',
  'mamam',
  'manda',
  'iinba',
  'mardi',
  'jalan',
  'ganka',
  'dirri',
  'oombi',
  'wajim',
  'indan',
  'boorr',
  'binda',
  'daboo',
  'aramb',
  'inggb',
  'ngaya',
  'ilmon',
  'yamar',
  'anjar',
  'narla',
  'ambab',
  'balab',
  'niidi',
  'bonim',
  'jarri',
  'malin',
  'ngarr',
  'inbal',
  'laago',
  'gayar',
  'iirra',
  'malbo',
  'gaaba',
  'birda',
  'ingan',
  'inggo',
  'arong',
  'giija',
  'moola',
]

if (CONFIG.normalization) {
  VALIDGUESSES.forEach(
    (val, i) => (VALIDGUESSES[i] = val.normalize(CONFIG.normalization))
  )
}
